import React from 'react';
import { inject, observer } from 'mobx-react';
import { Stack } from '@mantine/core';
import MedicalOverviewGraph from '../../HcpPatientDashboard/Graph/MedicalOverviewGraph.tsx';

export type IPatientMedicalOverviewProps = object;

const PatientMedicalOverview: React.FC<IPatientMedicalOverviewProps> = inject()(
    observer(() => {
        return (
            <Stack w="100%">
                <MedicalOverviewGraph />
            </Stack>
        );
    }),
);

export default PatientMedicalOverview;
